import RepositoryFactory from "../../admin/apis/index";
const variation = RepositoryFactory.EcomVariation;

export default {
  addVariation({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await variation.addVariation(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateVariation({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await variation.updateVariation(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getVariation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await variation.getVariation(payload);

        commit("SET_VARIATION", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteVariation({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await variation.deleteVariation(payload);

        // commit("SET_VARIATION", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  // productImage({}, payload) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       console.log("api called");
  //       const { data } = await product.productImage(payload);
  //       resolve(data);
  //     } catch (error) {
  //       console.log(error);
  //       reject(error);
  //     }
  //   });
  // },
};
